module.exports = __webpack_public_path__ + "img/4club-02.04b542d2.svg";